import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ConvenioPlanCargo} from '../../../_models/convenio-plan-cargo';
import {ConfirmationService} from 'primeng/api';
import {ConveniosConceptosService} from '../../../_services/convenios-conceptos.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {HomologacionPlanCargo} from '../../../_models/homologacion-plan-cargo';
import {NavService} from '../../../_services/_nav.service';

@Component({
  selector: 'app-convenios-plan-cargo-editar',
  templateUrl: './convenios-plan-cargo-editar.component.html',
  styleUrls: ['./convenios-plan-cargo-editar.component.css']
})
export class ConveniosPlanCargoEditarComponent implements OnInit {

  carInformacionInicial = true;
  formulario: FormGroup;
  submitted = false;
  convenioPlanCargo: ConvenioPlanCargo;
  guardando = false;
  actualizar = false;


  constructor( private fb: FormBuilder,
               private route: ActivatedRoute,
               private confirmationService: ConfirmationService,
               private convenioPlanCargoService: ConveniosConceptosService,
               private router: Router,
               private navService: NavService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe( async( params: Params ) => {
      if ( params[ 'id' ] ) {
        this.convenioPlanCargo = await this.convenioPlanCargoService.obtenerPorId(params['id']).toPromise();
        this.actualizar = true;
      }
      this.cargarFormulario();
    });
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      codigoConvenio: [this.convenioPlanCargo ? this.convenioPlanCargo.codigo : null, [Validators.maxLength(11)] ],
      nombreConvenio: [this.convenioPlanCargo ? this.convenioPlanCargo.nombre : null, [Validators.required, Validators.maxLength(250)], ],
      descripcion: [this.convenioPlanCargo ? this.convenioPlanCargo.descripcion : null, [Validators.maxLength(500)] ],
      indicadorHabilitado: [this.convenioPlanCargo ? this.convenioPlanCargo.indicadorHabilitado : true],
    });
    this.carInformacionInicial = false;
  }

  async onSubmit() {
    this.submitted = true;
    if ( !this.formulario.valid ) {
      return;
    }

    this.guardando = true;
    const data = this.formulario.getRawValue();
    const convenio =  this.convenioPlanCargo ? this.convenioPlanCargo : {} as ConvenioPlanCargo;
    convenio.codigo = data.codigoConvenio;
    convenio.nombre = data.nombreConvenio;
    convenio.descripcion = data.descripcion;
    convenio.indicadorHabilitado = data.indicadorHabilitado;

    if (convenio.idConvenioConcepto) {
      const actConvenio = await this.convenioPlanCargoService.actualizar(convenio).toPromise();
      this.convenioPlanCargo = actConvenio;
      this.navService.setMesage(2);
      this.formulario.markAsPristine();
      this.guardando = false;
      this.submitted = false;
      this.router.navigate(['apl/convenio-plan-cargo']);
      return;
    }

    const existe = await this.convenioPlanCargoService.buscarDobleRegistro(convenio.codigo).toPromise();
    if (!existe) {
      const guaConvenio = await this.convenioPlanCargoService.crear(convenio).toPromise();
      this.convenioPlanCargo = guaConvenio;
      this.navService.setMesage(1);
      this.formulario.markAsPristine();
      this.actualizar = true;
      this.guardando = false;
      this.submitted = false;
      this.router.navigate(['apl/convenio-plan-cargo']);
      return;
    } else {
      this.navService.setMesage(0, {
        severity: 'info',
        summary: this.navService.buscarMensaje('LBL_INFORMACION'),
        detail: this.navService.buscarMensaje('CONVENIOSPLANESCARGOS.LBL_DOBLECODIGO'),
      });
      this.guardando = false;
      this.submitted = false;
    }
  }

  get f() {
    return this.formulario.controls;
  }

  cancelar( fDirty: boolean ): void {
    if (fDirty) {
      this.confirmationService.confirm({
        message: ` ¿Se perderán los cambios realizados en el registro, esta seguro de cancelar??`,
        header: 'Confirmación',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.router.navigate(['apl/convenio-plan-cargo']);
        }
      });
    } else {
      this.router.navigate(['apl/convenio-plan-cargo']);
    }
  }

}
